<template>
  <div class="home">
    <full-page ref="fullpage" :options="options">
      <div class="section">
        <Banner class="banner1" :banner="bannerlist"></Banner>
      </div>
      <div class="section" :class="{ en_sec2: $i18n.locale == 'en' }">
        <About></About>
      </div>
      <div class="section">
        <Pro></Pro>
      </div>
      <div class="section">
        <AboutTwo></AboutTwo>
      </div>
      <div class="section fp-auto-height">
        <foot />
      </div>
    </full-page>

    <div class="block"></div>
  </div>
</template>

<script>
import Banner from "../components/banner";
import About from "../components/about";
import AboutTwo from "../components/about2";
import Pro from "../components/pro";
import foot from "@/components/foot.vue";
import { WOW } from "wowjs";
import Scrollbar from "smooth-scrollbar";
import { getHomeInfo } from "../util/lang";

export default {
  name: "home",
  data() {
    return {
      bannerlist: [],
      options: {
        licenseKey: "OPEN-SOURCE-GPLV3-LICENSE",
        /* 导航 */
        // 锚链接
        // anchors: ['l-header', 'l-map', 'l-newlist', 'l-app', 'l-footer'],
        default: false,
        // 如果设置为true，则会显示一个由小圆圈组成的导航栏
        navigation: true,
        // 定义导航栏显示的位置
        navigationPosition: "left",
        // 提示
        // navigationTooltips
        // default: false
        // 如果设置为true，则会显示一个导航栏，该导航栏由站点上每个横向滑块的小圆圈组成。
        // slidesNavigation: true,
        // slidesNavPosition: 'bottom',

        /* 滚动 */
        // 滚动转换的速度
        scrollingSpeed: 1000,
        // 使用“自动”滚动还是“正常”滚动, default true
        // autoScrolling: true,
        // 当前活动节将始终填充整个视口, default true
        // fitToSection: true,
        // 延迟多少毫秒 default 1000
        fitToSectionDelay: 2000,
        // 在滚动某些元素时避免自动滚动
        // normalScrollElements: '#footer',

        /* 可访问 */

        /* 设计 */
        // 是否使用幻灯片的控制箭头向右或向左移动, default: true
        controlArrows: false,
        // 是否在段落内部垂直居中, default: true
        verticalCentered: false,
        // 定义每个部分的 background-color, default: none
        sectionsColor: [
          "#f8f8f8",
          "rgba(128,128,128,0.06)",
          "rgba(128,128,128,0.06)",
          "rgba(128,128,128,0.06)",
          "#191919",
        ],
        // 定义每个部分的顶部填充, default 0
        // paddingTop: '70px',
        // fixedElements: '#magicalHeader',
        // default: 0
        // 一个正常的滚动（autoScrolling：false）将在定义的宽度下以像素为单位使用。
        // 如果用户希望将自己的响应式CSS用于身体标记
        // 则会将fp-responsive类添加到身体标记中。
        // 例如，如果设置为768，则每当浏览器的宽度小于768时，插件将像正常站点一样滚动。
        responsiveWidth: 1000,
        responsiveHeight: 576,
        // default: false
        // fullpage.js的扩展。 定义是否在节/幻灯片上使用视差背景效果。
        // 详细了解如何应用视差选项.
        // https://github.com/alvarotrigo/fullPage.js/wiki/Extension---Parallax
        parallax: false,

        /* 自定义选择器 */
        // 延迟加载
        lazyLoading: false,

        /* 事件 */
        css3: true,
        // scrollingSpeed:1000,
        // scrollBar: true,
        onLeave: this.onLeave,
        afterRender: this.afterRender,
      },
    };
  },
  mounted() {
    Scrollbar.initAll();
    setTimeout(() => {
      this.getContent();
    });
  },
  components: { Banner, About, AboutTwo, Pro, foot },
  methods: {
    getContent() {
      const url = `${getHomeInfo()}`;
      this.$axios.get(url).then((res) => {
        if (document.body.clientWidth < 1000) {
          this.bannerlist = res.data.m_banner;
        } else {
          this.bannerlist = res.data.banner;
        }
      });
    },
    onLeave(index, nextindex) {
      this.$store.commit("changeShortMenu", nextindex.index);
    },
    afterRender() {
      // this.wow= new WOW()
      // this.wow.init()
      this.$store.commit("changeReadFullpage");
    },
  },
};
</script>

<style lang="scss" scoped>

.home {
  width: 100%;
}
.section:nth-child(1) {
  height: 100vh !important;
}
@media screen and (max-width: 1000px) {
  // .en_sec2{
  //   height: 900px !important;
  // }
}
</style>
<style scoped>
#fp-nav {
  position: fixed;
  z-index: 100;
  margin-top: -32px;
  top: 50%;
  opacity: 1;
}
</style>
